import useSWR from 'swr'

const filterCompleted = (rental) => rental.status === 'completed'
const filterCancelled = (rental) => rental.status === 'cancelled'
const sortByDateAsc = (rentalA, rentalB) =>
  new Date(rentalA.booking_details.pickup_date) -
  new Date(rentalB.booking_details.pickup_date)

const sortByDateDesc = (rentalA, rentalB) =>
  new Date(rentalB.booking_details.pickup_date) -
  new Date(rentalA.booking_details.pickup_date)

function useCarRentals({ user }) {
  const { data, error } = useSWR(user ? '/me/car_bookings' : null)

  const rentals = data?.data || []

  const pastRentals =
    rentals
      ?.filter(filterCompleted)
      ?.filter(
        (rental) => new Date(rental.booking_details.return_date) < new Date()
      )
      ?.sort(sortByDateDesc) || []

  const upcomingRentals =
    rentals
      ?.filter(
        (rental) => new Date(rental.booking_details.return_date) >= new Date()
      )
      ?.filter((rental) => rental.status === 'completed')
      ?.sort(sortByDateAsc) || []

  const cancelledRentals =
    rentals?.filter(filterCancelled)?.sort(sortByDateDesc) || []

  return {
    rentals,
    pastRentals,
    upcomingRentals,
    cancelledRentals,
    isLoading: !error && !data,
    isError: error,
  }
}

export default useCarRentals
